"use client";

import { useEffect, useState } from "react";
import FeaturedSection from "./FeaturedSection"; // Version Desktop (Carousel)
import FeaturedArticles from "./FeaturedArticles"; // Version Mobile (Liste)
import { Article } from "@/types"; // Type centralisé

type Props = {
  articles: Article[];
};

const ResponsiveFeaturedSection: React.FC<Props> = ({ articles }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Vérifier la taille de l'écran
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 640); // Mobile si < 640px (taille SM de Tailwind)
    };

    checkScreenSize(); // Vérification au chargement
    window.addEventListener("resize", checkScreenSize); // Vérification dynamique

    return () => window.removeEventListener("resize", checkScreenSize); // Nettoyage
  }, []);

  return isMobile ? (
    <FeaturedArticles articles={articles.slice(0, 5)} />
  ) : (
    <FeaturedSection articles={articles} />
  );
};

export default ResponsiveFeaturedSection;
